import React from "react";
import className from "classnames/bind";
import useTranslations from "../../hooks/useTranslations";

/**
 * Component hiển thị thông báo trạng thái thanh toán
 * @param {Object} props
 * @param {boolean} props.isPaymentSuccess - Thanh toán thành công
 * @param {boolean} props.isPaymentFailed - Thanh toán thất bại
 * @param {boolean} props.isCODOrder - Đơn hàng COD
 * @param {string} props.orderId - Mã đơn hàng
 * @param {string} props.transactionNo - Mã giao dịch
 * @param {Object} props.styles - SCSS styles object
 */
const PaymentStatusMessage = ({
  isPaymentSuccess,
  isPaymentFailed,
  isCODOrder,
  orderId,
  transactionNo,
  styles,
}) => {
  const cx = className.bind(styles);
  const translations = useTranslations();

  if (isPaymentSuccess || isCODOrder) {
    return (
      <div className={cx("success-message")}>
        <h1>{translations?.PaymentSuccess?.title || "Payment Successful!"}</h1>
        <p>
          {isCODOrder
            ? (translations?.PaymentSuccess?.cod_message || "Your order has been placed. Please prepare cash for delivery.")
            : (translations?.PaymentSuccess?.message || "A copy of your receipt has been sent to your email.")
          }
        </p>
        {orderId && (
          <p>
            {translations?.PaymentSuccess?.order_id || "Order ID"}: <strong>{orderId}</strong>
          </p>
        )}
        {!isCODOrder && transactionNo && transactionNo !== "N/A" && (
          <p>
            {translations?.PaymentSuccess?.transaction_no || "Transaction No"}: <strong>{transactionNo}</strong>
          </p>
        )}
      </div>
    );
  }

  if (isPaymentFailed) {
    return (
      <div className={cx("error-message")}>
        <h1>{translations?.PaymentFailed?.title || "Payment Failed!"}</h1>
        <p>{translations?.PaymentFailed?.message || "Unfortunately, your payment could not be processed."}</p>
        <p>{translations?.PaymentFailed?.retry_message || "Please try again or contact customer support."}</p>
        {orderId && (
          <p>
            {translations?.PaymentSuccess?.order_id || "Order ID"}: <strong>{orderId}</strong>
          </p>
        )}
      </div>
    );
  }

  return (
    <div className={cx("pending-message")}>
      <h1>Payment Processing...</h1>
      <p>Your payment is being processed. Please wait for confirmation.</p>
    </div>
  );
};

export default PaymentStatusMessage;
